
import { SQLCourse } from './types';
import { phase3Modules } from './phase3Modules';

export const SQL_PHASE3_COURSE: SQLCourse = {
  id: "sql-phase3-modern-stack",
  title: "Modern Data Stack & Engineering",
  description: "Master the modern data stack with dbt, Airflow, streaming data, and advanced cloud platform capabilities.",
  level: "expert",
  durationHours: 16,
  tags: ["dbt", "Airflow", "Data Engineering", "Streaming", "Modern Stack", "ETL", "ELT", "DataOps"],
  imageSrc: "/placeholder.svg",
  image: "/placeholder.svg",
  modules: phase3Modules.map((module, index) => ({
    ...module,
    videoUrl: [
      "https://www.youtube.com/embed/HXV3zeQKqGY", // Advanced SQL Joins
      "https://www.youtube.com/embed/9yeOJ0ZMUYw", // AWS Advanced Analytics
      "https://www.youtube.com/embed/Yh4CrPHVBdE", // SQL Window Functions
      "https://www.youtube.com/embed/nWeW3sCmD2k"  // SQL Stored Procedures
    ][index] || "https://www.youtube.com/embed/HXV3zeQKqGY",
    duration: [
      "60 minutes", // Advanced SQL Joins
      "75 minutes", // AWS Advanced Analytics
      "60 minutes", // SQL Window Functions
      "60 minutes"  // SQL Stored Procedures
    ][index] || "60 minutes"
  })),
  totalDuration: "8 hours",
  requirements: [
    "Completion of SQL Advanced Analytics course",
    "Experience with cloud databases",
    "Understanding of data engineering concepts",
    "Familiarity with version control (Git)"
  ]
};
